import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IEntityComponentsAddressesModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: EntityComponentsAddressesModuleConfigToken, useValue: entityComponentsAddressesModuleConfig },
 * ],
 */
const EntityComponentsAddressesModuleConfigToken = new InjectionToken('entity_components_addresses_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { EntityComponentsAddressesModuleConfigToken };

//# sourceMappingURL=mt-ng2-entity-components-addresses-config.js.map